export default {
  NoPointsSet: 1,
  SomePointsBelow: 2,
  AllPointsAbove: 3
}

